
// @group components

export default {
  name: 'TextBlockComponent',
  props: ['data'],
}
